import Button from "@elements/button";
import Slider from "rc-slider";
import Accordion from "@elements/accordion";
import { IFilterInput, IFilterOutput } from "types/api/product";
import { useTranslations } from "next-intl";
import { convertNumber } from "@utils/digits";
import { useRouter } from "next/router";
import useFilters from "@hooks/useFilters";
interface Props {
  items: IFilterInput[];
  defaultFilters?: IFilterOutput[];
  action: (data: IFilterOutput[]) => void;
}

const Filters: React.FC<Props> = ({ items, defaultFilters, action }) => {
  const t = useTranslations();
  const { locale } = useRouter();
  const { filters, resetAll, handelFilters, handelRangeFilter, handelSubmitFilters } = useFilters(action, defaultFilters)


  return (
    <div className="">
      <div className="w-full flex flex-wrap justify-between items-center h-16">
        <p className=" font-bold text-xl">
          {t("client_filters_filter")} {filters.length ? `(${filters.length})` : ""}
        </p>
        <button
          className=" text-[#008AF6] font-normal text-sm"
          onClick={() => resetAll()}
        >
          {t("client_buttons_resetall")}
        </button>
      </div>
      <div className="w-full overflow-x-hidden  overflow-y-auto">
        {items.map((item, index) => (
          <div
            className={`w-full pt-2 pb-2 ${index + 1 === items.length ? "" : "border-b"
              }`}
            key={`${item.title}-${item.slug}`}
          >
            <Accordion
              title={`${item.title} ${filters.find((f) => f.key === item.key)?.range
                ? `(${filters.find((f) => f.key === item.key)?.range?.min
                } - ${filters.find((f) => f.key === item.key)?.range?.max})`
                : ""
                }`}
              open={filters.find((f) => f.key === item.key) ? true : false}
            >
              <div className="w-full  flex flex-wrap pl-3 pr-3 ">
                {item.type === "singleSelect" &&
                  item.items?.map((f, i) => (
                    <button
                      className={`${filters.find((f) => f.id === item.id) &&
                        filters
                          .find((f) => f.id === item.id)
                          ?.items?.includes(f.value)
                        ? " border-[#008AF6] text-[#008AF6] border bg-[#008AF6] bg-opacity-10"
                        : "border-[#eee] text-[#AAA] border"
                        }  rounded-[20px]  h-10  px-5 mb-2 font-normal text-xs mr-2 !w-max`}
                      key={`${f.title}-${f.slug}`}
                      onClick={() => handelFilters(item, f.value)}
                    >
                      {convertNumber(locale, f.title)}
                    </button>
                  ))}

                {item.type === "range" && (
                  <div className=" w-[93%] mx-auto">
                    <Slider
                      marks={{
                        [`${item.range?.min}`]: `${item.range?.min}`,
                        [`${item.range?.max}`]: `${item.range?.max}`,
                      }}
                      min={item.range?.min}
                      max={item.range?.max}
                      value={
                        filters.find((f) => f.id === item.id)?.range
                          ? [
                            filters.find((f) => f.id === item.id)?.range
                              ?.min as number,
                            filters.find((f) => f.key === item.key)?.range
                              ?.max as number,
                          ]
                          : [
                            item.range?.min as number,
                            item.range?.max as number,
                          ]
                      }
                      range
                      onChange={(e: number[] | number) =>
                        handelRangeFilter(item, e as any)
                      }
                    />
                  </div>
                )}
                {item.type === "multiSelect" &&
                  item.items?.map((f, i) => (
                    <div
                      className="w-full flex items-center mb-2"
                      key={`${f.title}-${f.slug}`}
                    >
                      <input
                        type="checkbox"
                        id="1"
                        name={f.title}
                        value={f.value}
                        onClick={() => handelFilters(item, f.value)}
                        checked={
                          filters.find((f) => f.id === item.id) &&
                          filters
                            .find((f) => f.id === item.id)
                            ?.items?.includes(f.value)
                        }
                      />
                      <label
                        className=" font-normal text-sm text-[#333333] mx-1 capitalize"
                        htmlFor={f.title}
                      >
                        {" "}
                        {f.title}
                      </label>
                    </div>
                  ))}
              </div>
            </Accordion>
          </div>
        ))}
      </div>
      <div className="w-full  py-1 overflow-y-hidden">
        <Button
          className="w-full h-12 font-extrabold text-base rounded-full !shadow-none"
          noAnimation
          size="slim"
          onClick={() => handelSubmitFilters()}
        >
          {t("client_buttons_apply")}
        </Button>
      </div>
    </div>
  );
};

export default Filters;
